/* eslint-disable i18next/no-literal-string */

import { Box, Typography } from "@outschool/backpack";
import React from "react";

import { CREATURE_TYPES } from "./avatar-builder-constants";
import { ChipButton } from "./AvatarBuilderFormControls";

export interface AvatarBuilderTypeTabProps {
  creatureType: string;
  setCreatureType: React.Dispatch<React.SetStateAction<string>>;
}

export function AvatarBuilderTypeTab({
  creatureType,
  setCreatureType,
}: AvatarBuilderTypeTabProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        padding: "0px 5px",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{ fontSize: "1.5rem", fontWeight: 600 }}
      >
        Avatar type
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
          gap: 8,
          minWidth: 0,
        }}
      >
        {CREATURE_TYPES.map(ct => (
          <ChipButton
            key={ct.value}
            label={ct.label}
            icon={ct.icon}
            selected={creatureType === ct.value}
            onClick={() => setCreatureType(ct.value)}
          />
        ))}
      </Box>
    </Box>
  );
}
